import React from 'react';
import { renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderAmount } from 'modules/saas/invoices';
import { renderCaseCustomer } from 'modules/saas/common/columns';

export const list = () => {
  const rowClickedUrl = id => '';
  const loadNextUrl = '/customer/invoices.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns, {
    rowHeight: 60,
  });
};

const renderAction = ({ rowData }) => {
  const id = rowData.id;

  return (
    <div>
      <a
        href={`/customer/invoices/${id}/pdf`}
        target="_blank"
        className="ui basic button"
      >
        <i className="file pdf outline icon" />
        PDF
      </a>
    </div>
  );
};

function renderColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={width / 16 * 2}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="customer"
      dataKey="customer"
      width={width / 16 * 4}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="number"
      dataKey="number"
      width={width / 16 * 3}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={width / 16 * 2}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={width / 16 * 2}
      label="Date de règlement"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={width / 16 * 3}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/customer/invoices.js